<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-12 12:56:28
 * @Description: TODO
-->
<template>
  <div class="order-div col">
    <dv-scroll-board :config="{...config,data}"></dv-scroll-board>
  </div>
</template>

<script>
export default {
  name: 'Order',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      config: {
        header: [
          '交易日期',
          '品名',
          '交易数量\n(吨)',
          '交易单价\n(元/吨)',
          '交易金额\n(万元)',
          '下游企业'
        ],
        data: [
        ],
        headerHeight: 40,
        rowNum: 8,
        align: ['center', 'center', 'center', 'center', 'center', 'center'],
        oddRowBGC: '#091d45',
        evenRowBGC: '#0f3058'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-div {
  height: 100%;
}

::v-deep .header .header-item {
    &:not(:first-child) {
      border-left: solid 3px black !important;
    }
  word-wrap: break-word; /* 自动换行 */
}
 ::v-deep .dv-scroll-board .rows .ceil{
  &:not(:first-child) {
      border-left: solid 3px black !important;
    }
}
</style>
